/**
 * Utility functions for Epic ID formatting
 */

/**
 * Pads an Epic ID with leading zeroes to ensure minimum 5 digits
 * @param epicId - The Epic ID as string or number
 * @returns Padded Epic ID as string (minimum 5 digits)
 */
export const padEpicId = (epicId: string | number | null | undefined): string => {
  if (epicId === null || epicId === undefined || epicId === '') {
    return 'N/A';
  }

  const idStr = String(epicId).trim();

  // If not a valid number, return as-is
  if (!/^\d+$/.test(idStr)) {
    return idStr;
  }

  // Pad with leading zeroes to minimum 5 digits
  return idStr.padStart(5, '0');
};

/**
 * Pads all Epic IDs in a CSV string
 * @param csvIds - Comma-separated Epic IDs
 * @returns Comma-separated padded Epic IDs
 */
export const padEpicIdCsv = (csvIds: string | null | undefined): string => {
  if (!csvIds || csvIds.trim() === '') {
    return '';
  }

  return csvIds
    .split(',')
    .map(id => padEpicId(id.trim()))
    .join(',');
};
